import { render } from "./KryptonPopinHeaderLabelDefault.vue?vue&type=template&id=6299c440&lang=pug"
import script from "./KryptonPopinHeaderLabelDefault.vue?vue&type=script&lang=js"
export * from "./KryptonPopinHeaderLabelDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__